import { Component, OnInit } from '@angular/core';
import {WeeeSystems} from '../../models/weee_systems.interface';
import {Page} from '../../../shared/models/page.interface';
import {WeeeSystemSearch} from '../../models/weee_system_search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {WeeeSystemService} from '../../services/weee-system.service';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {Countries} from '../../models/countries.interface';
import {CountriesService} from '../../services/countries.service';

@Component({
  selector: 'app-weee-system',
  templateUrl: './weee-system.component.html',
  styleUrls: ['./weee-system.component.scss']
})
export class WeeeSystemComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  weeeSystems!: Page<WeeeSystems>;
  countries!: Countries[];
  private search!: WeeeSystemSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'country.name', direction: 'asc'};

  constructor(private readonly weeeSystemService: WeeeSystemService,
              private readonly countriesService: CountriesService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.weeeSystemService.getAll({status: 2}, this.page).subscribe(
      data => this.weeeSystems = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
    this.countriesService.getAll({status: 2}, {page: 0, size: 1000, sort: 'name', direction: 'asc'}).subscribe(
      data => this.countries = data.content
    );
  }

  loadWeeeSystems(event: PageRequest): void {
    this.page = event;
    if (this.search) {
      this.weeeSystemService.getAll(this.search, event).subscribe(
        data => this.weeeSystems = data
      );
    }
    else {
      this.weeeSystemService.getAll({status: 2}, event).subscribe(
        data => this.weeeSystems = data
      );
    }
  }

  searchWeeeSystems(search: WeeeSystemSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'country.name', direction: 'asc'};
    }
    this.weeeSystemService.getAll(search, this.page).subscribe(
      data => this.weeeSystems = data
    );
  }

  updateWeeeSystemStatus(id: number): void {
    this.weeeSystemService.updateWeeeSystem(id).subscribe(
      () => this.updateData()
    );
  }

  deleteWeeeSystem(id: number): void {
    this.weeeSystemService.deleteWeeeSystem(id).subscribe(
      () => this.updateData()
    );
  }

  private updateData(): void {
    if (this.search) {
      this.weeeSystemService.getAll(this.search, this.page).subscribe(
        data => this.weeeSystems = data
      );
    }
    else {
      this.weeeSystemService.getAll({status: 2}, this.page).subscribe(
        data => this.weeeSystems = data
      );
    }
  }

}
